import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeFormFieldQuantityModule } from 'se-fe-form-field-quantity'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiSetupBarModule } from '../lib/shared-ui-setup-bar.module'
import { SetupBarDocsComponent } from './setup-bar-docs/setup-bar-docs.component'
import { SetupBarExampleComponent } from './setup-bar-docs/setup-bar-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeFormFieldQuantityModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiSetupBarModule
  ],
  declarations: [
    SetupBarDocsComponent,
    SetupBarExampleComponent
  ],
  exports: [
    SetupBarDocsComponent
  ]
})
export class SharedUiSetupBarDocsModule {}
